export default __webpack_public_path__ + "static/media/blank-profile.8b6e3dd6.svg";